import { projections } from '~/components/input-geo/input-geo.controller';

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevInputGeoController {
	/* @ngInject */
	constructor() {
		this.data = {
			c: {
				lat: 46.792_704,
				lng: 4.859_494_4,
			},
			p: 'WGS84',
		};
		this.jsonEditorOptions = {
			mode:  'code',
			modes: [
				'code',
				'form',
				'text',
				'tree',
				'view',
			],
		};
		this.options = {
			availableProjections:      projections.map(p => p.id),
			showCurrentPositionButton: true,
			showMapButton:             true,
			showProjectionSelection:   true,
		};
		this.projection = 'WGS84';
		this.projections = projections;
		this.readOnly = false;
		this.required = true;
	}

	toggleSelectionAvailableProjection(/** @type {any} */ projection) {
		const index = this.options.availableProjections.indexOf(projection.id);

		// Is currently selected
		if (index > -1) {
			this.options.availableProjections.splice(index, 1);
		}
		// Is newly selected
		else {
			this.options.availableProjections.push(projection.id);
		}
	}
}
